export const LOAD_DATA = 'FEATURE_LOAD_DATA';

/**
 * load features data.
 */
export const load = () => {
    return {
      type: LOAD_DATA
    }
  }